import React from 'react';
import ForgotPasswordForm from '../../components/ForgotPassword';

const ForgotPassword = () => {
    return (
        <div className="login-page">
            <div className="left-panel">
                <p className="left-text">Conversations Evolved. Intelligence Delivered.</p>
            </div>

            <div className="right-panel">
                <ForgotPasswordForm />
            </div>
        </div>
    );
};

export default ForgotPassword;